import { isNil, omitBy, map, filter } from "lodash";
import moment from "moment";

const constructDate = (date, format?) => {
  if (!date) return null;

  const isMoment = moment(date, format).isValid();

  if (!isMoment) return null;

  return moment(date, format);
};

const response = (data: any, inactiveSettings?) => {
  const convertData = (input) => {
    const normalizedData = omitBy(
      {
        isFixedAmount: !!input?.surcharge?.fixedAmount,
        isPercentage: !!input?.surcharge?.percentage,
        fixedAmount: input?.surcharge?.fixedAmount || null,
        percentage: input?.surcharge?.percentage || null,
        capAmount: input?.surcharge?.capAmount || null,
        validFrom: input?.validFrom ? moment(input.validFrom) : null,
        validTo: input?.validTo ? moment(input.validTo) : null,
        length: input?.maxDimension?.length,
        width: input?.maxDimension?.width,
        height: input?.maxDimension?.height,
        cutOffTime: constructDate(input.cutOffTime, "HH:mm"),
        estimatedTime: constructDate(input.estimatedTime, "HH:mm"),
      },
      isNil,
    );

    return normalizedData;
  };

  const activeVersion = {
    ...data,
    ...data.data,
    ...convertData(data.data),
  };

  data.versions = filter(inactiveSettings, (inactiveSettingObj) => {
    return inactiveSettingObj.code == data.code;
  });

  let versionList = map(data.versions, (versionObj) => {
    return { ...versionObj, ...convertData(versionObj) };
  });

  versionList.unshift(activeVersion);

  return omitBy(
    {
      ...activeVersion,
      versions: versionList,
    },
    isNil,
  );
};

export default response;
